import { FormEvent, useState } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { KeyRound, LogIn } from 'lucide-react'
import { EntrarComoDev } from '../components/dev/EntrarComoDev'
import { Alerta, Boton, Campo, Cargando, Entrada, Panel } from '../components/kit'
import { APP_NOMBRE } from '../config'
import { useAuth } from '../contexts/AuthProvider'
import { useInfo } from '../queries/useInfo'
import { authService } from '../services/authService'
import { mensajeDeError } from '../utils/errores'
import { destinoSeguro, mensajeErrorLogin } from '../utils/login'

/**
 * Entrar. La vía principal es U-Pasaporte (portal VTI del DCC); el formulario con
 * contraseña es para cuentas locales creadas en el admin (externos, soporte). Qué
 * vías se muestran lo dice el backend (GET /api/info/).
 */
export default function Login() {
  const [params] = useSearchParams()
  const destino = destinoSeguro(params.get('next'))
  const errorPortal = mensajeErrorLogin(params.get('error'))
  const { conSesion, estado, login } = useAuth()
  const info = useInfo()
  const [conClave, setConClave] = useState(false)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [enviando, setEnviando] = useState(false)
  const [error, setError] = useState<string | null>(null)

  if (conSesion) return <Navigate to={destino} replace />
  if (estado === 'desconocido' || estado === 'verificando' || info.isLoading) return <Cargando />

  const vias = info.data?.login
  const enviar = async (e: FormEvent) => {
    e.preventDefault()
    setEnviando(true)
    setError(null)
    try {
      await login(username, password)
    } catch (err) {
      setError(mensajeDeError(err, 'No se pudo iniciar sesión.'))
    } finally {
      setEnviando(false)
    }
  }

  return (
    <div className="login">
      <Panel titulo={`Entrar a ${APP_NOMBRE}`}>
        <div className="pila">
          {errorPortal && <Alerta tipo="error">{errorPortal}</Alerta>}
          {info.isError && <Alerta tipo="error">No se pudo contactar al servidor.</Alerta>}

          {vias?.vti && (
            <>
              <p className="texto-secundario">Con tu cuenta de la Universidad de Chile.</p>
              <Boton tam="lg" icono={LogIn} href={authService.urlLoginVti(destino)} className="login__principal">
                Entrar con U-Pasaporte
              </Boton>
            </>
          )}

          {vias?.local && !conClave && (
            <Boton variante="text" icono={KeyRound} onClick={() => setConClave(true)}>
              Entrar con usuario y contraseña
            </Boton>
          )}
          {vias?.local && conClave && (
            <form className="pila" onSubmit={enviar}>
              {error && <Alerta tipo="error">{error}</Alerta>}
              <Campo etiqueta="Usuario" requerido>
                <Entrada autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} required autoFocus />
              </Campo>
              <Campo etiqueta="Contraseña" requerido>
                <Entrada type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
              </Campo>
              <Boton type="submit" cargando={enviando}>Entrar</Boton>
            </form>
          )}

          {vias && !vias.vti && !vias.local && !vias.dev && (
            <Alerta tipo="error">Este ambiente no tiene ninguna vía de ingreso habilitada.</Alerta>
          )}
        </div>
      </Panel>

      {vias?.dev && (
        <Panel titulo="Desarrollo">
          <EntrarComoDev destino={destino} />
        </Panel>
      )}
    </div>
  )
}
